// src/moodConfig.js
// Single source of truth for mood options and colors

export const MOODS = [
  { id: "ecstatic", label: "Ecstatic", color: "#f9b31c" },
  { id: "happy", label: "Happy", color: "#2daa44" },
  { id: "neutral", label: "Neutral", color: "#3677ef" },
  { id: "sad", label: "Sad", color: "#399cfa" },
  { id: "angry", label: "Angry", color: "#ef4444" },
];

export const MOOD_IDS = MOODS.map((m) => m.id);

/** Normalize legacy mood values from DB to new mood ids (for backward compatibility) */
export function normalizeMood(mood) {
  if (!mood) return undefined;
  const legacy = { red: "angry", orange: "neutral", green: "happy" };
  return legacy[mood] || (MOOD_IDS.includes(mood) ? mood : undefined);
}

export function getMoodLabel(moodId) {
  return MOODS.find((m) => m.id === moodId)?.label ?? moodId;
}

export function getMoodColor(moodId) {
  return MOODS.find((m) => m.id === moodId)?.color ?? "#94a3b8";
}
